import type { DetailedHTMLProps, HTMLAttributes } from 'react';

interface PaymentMethodSelectionOptionProps
  extends Omit<
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'className'
  > {
  children: React.ReactNode;
  active?: boolean;
  name?: string;
  disabled?: boolean;
}

export const DigitalWalletSelectionOption = ({
  children,
  active,
  name,
  disabled,
  ...props
}: PaymentMethodSelectionOptionProps) => {
  return (
    <div
      {...props}
      className={`w-full ${
        active
          ? 'bg-jade-background-brand-subtle-hover'
          : 'bg-jade-background-surface'
      } ${
        disabled && 'opacity-50 cursor-not-allowed'
      } cursor-pointer shadow-sm p-jade-150 rounded-jade-medium
        h-[30px]
        border-jade-small border-solid border-jade-border-low flex flex-1 justify-center items-center`}
      data-testid={'digital-wallet-selection-option' + (name ? `-${name}` : '')}
    >
      {children}
    </div>
  );
};
